'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$00242 from "./presto.-Audit-View$$anon$2.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$00244 from "./presto.-Audit-View$$anon$4.js";
import * as $j_presto$002e$002dAudit$002dView$0024$0024anon$00246 from "./presto.-Audit-View$$anon$6.js";
import * as $j_presto$002e$002dAudit$002dView$0024$002dAudit$002dResult$0024 from "./presto.-Audit-View$-Audit-Result$.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$$anon$1(outer) {
  this.aAz = null;
  this.aAr = null;
  this.aAs = false;
  this.aAA = null;
  this.aAB = false;
  this.aAE = null;
  this.aAx = null;
  this.aAy = false;
  this.aAt = null;
  this.aAu = false;
  this.aAv = null;
  this.aAw = false;
  this.aAC = false;
  this.aAD = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aAz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aAE = "AuditResult";
}
export { $c_Lpresto_AuditView$$anon$1 as $c_Lpresto_AuditView$$anon$1 };
$p = $c_Lpresto_AuditView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$$anon$1;
/** @constructor */
function $h_Lpresto_AuditView$$anon$1() {
}
export { $h_Lpresto_AuditView$$anon$1 as $h_Lpresto_AuditView$$anon$1 };
$h_Lpresto_AuditView$$anon$1.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aAz;
});
$p.M = (function() {
  if ((!this.aAs)) {
    this.aAr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aAs = true;
  }
  return this.aAr;
});
$p.O = (function() {
  if ((!this.aAB)) {
    this.aAA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aAB = true;
  }
  return this.aAA;
});
$p.E = (function() {
  return this.aAE;
});
$p.t = (function() {
  if ((!this.aAy)) {
    this.aAx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("items", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("page", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("size", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("until", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("names", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aAy = true;
  }
  return this.aAx;
});
$p.N = (function() {
  if ((!this.aAu)) {
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
    var $x_6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dAudit$002dView$0024$0024anon$00242.$c_Lpresto_AuditView$$anon$2());
    var $x_5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB;
    var $x_3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB;
    var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z();
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_KeyDecoder$().Av;
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
    var decodeK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_KeyDecoder$().Av;
    $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$();
    this.aAt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($x_6, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($x_5, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($x_4, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($x_3, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($x_2, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$43($x_1, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$43(decodeK, new $j_presto$002e$002dAudit$002dView$0024$0024anon$00244.$c_Lpresto_AuditView$$anon$4())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.aAu = true;
  }
  return this.aAt;
});
$p.Q = (function() {
  if ((!this.aAw)) {
    this.aAv = new $j_presto$002e$002dAudit$002dView$0024$0024anon$00246.$c_Lpresto_AuditView$$anon$6();
    this.aAw = true;
  }
  return this.aAv;
});
$p.v = (function() {
  if ((!this.aAD)) {
    this.aAC = false;
    this.aAD = true;
  }
  return this.aAC;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee74) => ((p) => \u03b4scrutinee74.cFr(p)))($j_presto$002e$002dAudit$002dView$0024$002dAudit$002dResult$0024.$m_Lpresto_AuditView$AuditResult$())));
});
var $d_Lpresto_AuditView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$$anon$1, "presto.AuditView$$anon$1", ({
  Er: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AuditView$$anon$1 as $d_Lpresto_AuditView$$anon$1 };
//# sourceMappingURL=presto.-Audit-View$$anon$1.js.map
